import { ModalContent as ChakraModalContent } from "@chakra-ui/react";

export const ModalContent = ChakraModalContent;
